/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Page_Rail_RemindInputs */

const en_how_page_rail_remind = /** @type {(inputs: How_Page_Rail_RemindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reminder`)
};

const pl_how_page_rail_remind = /** @type {(inputs: How_Page_Rail_RemindInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przypomnienie`)
};

/**
* | output |
* | --- |
* | "Reminder" |
*
* @param {How_Page_Rail_RemindInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const how_page_rail_remind = /** @type {((inputs?: How_Page_Rail_RemindInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Page_Rail_RemindInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_how_page_rail_remind(inputs)
	return en_how_page_rail_remind(inputs)
});